export default "__VITE_ASSET__Dpw4hpPh__"